
import baseService from './baseService'

export const userService = {
  login,
  getUserGuide
}


function login(username, password, meta) {
  return baseService.postRequest('users/authenticate', { username, password, meta })
}
function getUserGuide(lang, productKey) {

  if (!lang || !productKey) {
    return Promise.reject(new Error('Language and product key are required'))
  }

  const endpoint = `public/product/${lang}/${productKey}`
  return baseService.getRequest(endpoint, {})
}
